module.exports = __webpack_public_path__ + "img/11087924_S.9b9e6fd5.png";